module.exports = __webpack_public_path__ + "img/id-menu-2.df23385c.svg";